// ─── Theme tokens ─────────────────────────────────────────────────────────────
export const C = {
  bg:           '#0D0D1A',
  bg2:          '#15142A',
  cardBg:       'rgba(255,255,255,0.04)',
  cardBgHover:  'rgba(255,255,255,0.07)',
  border:       'rgba(255,255,255,0.08)',
  borderStrong: 'rgba(255,255,255,0.18)',
  cyan:         '#00E5FF',
  pink:         '#FF4D9E',
  white:        '#FFFFFF',
  textDim:      '#A0AEC0',
  textDimmer:   '#6B7184',
  ink:          '#0D0D1A',
};

// ─── Tamil Nadu ────────────────────────────────────────────────────────────────
const TN_PARTIES = [
  { id: 'TVK',    en: 'TVK',    local: 'தமிழக வெற்றிக் கழகம்',          color: '#00897B' },
  { id: 'DMK',    en: 'DMK',    local: 'திமுக',                        color: '#E53935' },
  { id: 'AIADMK', en: 'AIADMK', local: 'அதிமுக',                       color: '#43A047' },
  { id: 'PMK',    en: 'PMK',    local: 'பாமக',                         color: '#FB8C00' },
  { id: 'IUML',   en: 'IUML',   local: 'இந்திய யூனியன் முஸ்லிம் லீக்',  color: '#2E7D32' },
  { id: 'VCK',    en: 'VCK',    local: 'விடுதலை சிறுத்தைகள்',           color: '#1E88E5' },
  { id: 'CPI',    en: 'CPI',    local: 'இந்திய கம்யூனிஸ்ட் கட்சி',      color: '#B71C1C' },
  { id: 'BJP',    en: 'BJP',    local: 'பாரதிய ஜனதா கட்சி',             color: '#FF6F00' },
  { id: 'DMDK',   en: 'DMDK',   local: 'தேசிய முற்போக்கு திராவிட கழகம்', color: '#F9A825' },
  { id: 'NTK',    en: 'NTK',    local: 'நாம் தமிழர் கட்சி',              color: '#7B1FA2' },
];

const TN_DISTRICTS = [
  { en: 'Tiruvallur',      local: 'திருவள்ளூர்',        col: 5, row: 0 },
  { en: 'Chennai',         local: 'சென்னை',             col: 6, row: 0 },
  { en: 'Krishnagiri',     local: 'கிருஷ்ணகிரி',        col: 1, row: 1 },
  { en: 'Tirupattur',      local: 'திருப்பத்தூர்',      col: 2, row: 1 },
  { en: 'Vellore',         local: 'வேலூர்',             col: 3, row: 1 },
  { en: 'Ranipet',         local: 'ராணிப்பேட்டை',       col: 4, row: 1 },
  { en: 'Kancheepuram',    local: 'காஞ்சிபுரம்',        col: 5, row: 1 },
  { en: 'Chengalpattu',    local: 'செங்கல்பட்டு',       col: 6, row: 1 },
  { en: 'Dharmapuri',      local: 'தர்மபுரி',           col: 1, row: 2 },
  { en: 'Salem',           local: 'சேலம்',              col: 2, row: 2 },
  { en: 'Tiruvannamalai',  local: 'திருவண்ணாமலை',      col: 3, row: 2 },
  { en: 'Villupuram',      local: 'விழுப்புரம்',        col: 4, row: 2 },
  { en: 'Cuddalore',       local: 'கடலூர்',             col: 5, row: 2 },
  { en: 'Nilgiris',        local: 'நீலகிரி',            col: 0, row: 3 },
  { en: 'Erode',           local: 'ஈரோடு',              col: 1, row: 3 },
  { en: 'Namakkal',        local: 'நாமக்கல்',           col: 2, row: 3 },
  { en: 'Kallakurichi',    local: 'கள்ளக்குறிச்சி',     col: 4, row: 3 },
  { en: 'Ariyalur',        local: 'அரியலூர்',           col: 5, row: 3 },
  { en: 'Coimbatore',      local: 'கோயம்புத்தூர்',      col: 0, row: 4 },
  { en: 'Tiruppur',        local: 'திருப்பூர்',         col: 1, row: 4 },
  { en: 'Karur',           local: 'கரூர்',              col: 2, row: 4 },
  { en: 'Tiruchirappalli', local: 'திருச்சிராப்பள்ளி',  col: 3, row: 4 },
  { en: 'Perambalur',      local: 'பெரம்பலூர்',         col: 4, row: 4 },
  { en: 'Mayiladuthurai',  local: 'மயிலாடுதுறை',        col: 6, row: 4 },
  { en: 'Theni',           local: 'தேனி',               col: 1, row: 5 },
  { en: 'Dindigul',        local: 'திண்டுக்கல்',        col: 2, row: 5 },
  { en: 'Pudukkottai',     local: 'புதுக்கோட்டை',       col: 3, row: 5 },
  { en: 'Thanjavur',       local: 'தஞ்சாவூர்',          col: 4, row: 5 },
  { en: 'Tiruvarur',       local: 'திருவாரூர்',         col: 5, row: 5 },
  { en: 'Nagapattinam',    local: 'நாகப்பட்டினம்',      col: 6, row: 5 },
  { en: 'Madurai',         local: 'மதுரை',              col: 2, row: 6 },
  { en: 'Sivaganga',       local: 'சிவகங்கை',           col: 3, row: 6 },
  { en: 'Ramanathapuram',  local: 'ராமநாதபுரம்',        col: 4, row: 6 },
  { en: 'Tenkasi',         local: 'தென்காசி',           col: 1, row: 7 },
  { en: 'Virudhunagar',    local: 'விருதுநகர்',         col: 2, row: 7 },
  { en: 'Thoothukudi',     local: 'தூத்துக்குடி',       col: 3, row: 7 },
  { en: 'Tirunelveli',     local: 'திருநெல்வேலி',       col: 2, row: 8 },
  { en: 'Kanniyakumari',   local: 'கன்னியாகுமரி',       col: 2, row: 9 },
];

// ─── West Bengal ──────────────────────────────────────────────────────────────
const WB_PARTIES = [
  { id: 'TMC',  en: 'AITC',    local: 'সর্বভারতীয় তৃণমূল কংগ্রেস', color: '#009966' },
  { id: 'BJP',  en: 'BJP',     local: 'ভারতীয় জনতা পার্টি',         color: '#FF6F00' },
  { id: 'CPM',  en: 'CPI(M)',  local: 'সিপিআই(এম)',                   color: '#E53935' },
  { id: 'INC',  en: 'INC',     local: 'ভারতীয় জাতীয় কংগ্রেস',     color: '#1E88E5' },
  { id: 'ISF',  en: 'AISF',   local: 'সর্বভারতীয় ধর্মনিরপেক্ষ মঞ্চ', color: '#7B1FA2' },
  { id: 'CPI',  en: 'AJUP',   local: 'আমরা জাতীয় উন্নয়ন পার্টি',    color: '#B71C1C' },
];

// Geographic tile layout — 5 cols (0-4), 8 rows (0-7)
const WB_DISTRICTS = [
  { en: 'Darjeeling',        local: 'দার্জিলিং',           col: 0, row: 0 },
  { en: 'Kalimpong',         local: 'কালিম্পং',             col: 1, row: 0 },
  { en: 'Jalpaiguri',        local: 'জলপাইগুড়ি',           col: 2, row: 0 },
  { en: 'Alipurduar',        local: 'আলিপুরদুয়ার',          col: 4, row: 0 },
  { en: 'Uttar Dinajpur',    local: 'উত্তর দিনাজপুর',       col: 1, row: 1 },
  { en: 'Cooch Behar',       local: 'কোচবিহার',             col: 4, row: 1 },
  { en: 'Dakshin Dinajpur',  local: 'দক্ষিণ দিনাজপুর',     col: 1, row: 2 },
  { en: 'Malda',             local: 'মালদা',                col: 2, row: 2 },
  { en: 'Birbhum',           local: 'বীরভূম',               col: 1, row: 3 },
  { en: 'Murshidabad',       local: 'মুর্শিদাবাদ',           col: 3, row: 3 },
  { en: 'Paschim Bardhaman', local: 'পশ্চিম বর্ধমান',        col: 0, row: 4 },
  { en: 'Purba Bardhaman',   local: 'পূর্ব বর্ধমান',         col: 2, row: 4 },
  { en: 'Nadia',             local: 'নদিয়া',                col: 3, row: 4 },
  { en: 'North 24 Parganas', local: 'উত্তর ২৪ পরগনা',       col: 4, row: 4 },
  { en: 'Bankura',           local: 'বাঁকুড়া',              col: 0, row: 5 },
  { en: 'Hooghly',           local: 'হুগলি',                col: 2, row: 5 },
  { en: 'Howrah',            local: 'হাওড়া',                col: 3, row: 5 },
  { en: 'Kolkata',           local: 'কলকাতা',               col: 4, row: 5 },
  { en: 'Purulia',           local: 'পুরুলিয়া',             col: 0, row: 6 },
  { en: 'Jhargram',          local: 'ঝাড়গ্রাম',             col: 1, row: 6 },
  { en: 'Paschim Medinipur', local: 'পশ্চিম মেদিনীপুর',      col: 2, row: 6 },
  { en: 'Purba Medinipur',   local: 'পূর্ব মেদিনীপুর',       col: 4, row: 6 },
  { en: 'South 24 Parganas', local: 'দক্ষিণ ২৪ পরগনা',      col: 3, row: 7 },
];

// ─── CJP (Cockroach Janta Party) — Mock 2029 National Ballot ──────────────────
const CJP_PARTIES = [
  { id: 'CJP',  en: 'CJP',  local: 'Cockroach Janta Party',         color: '#8B5E3C', featured: true },
  { id: 'BJP',  en: 'BJP',  local: 'Bharatiya Janata Party',         color: '#FF9933' },
  { id: 'INC',  en: 'INC',  local: 'Indian National Congress',       color: '#138808' },
  { id: 'AAP',  en: 'AAP',  local: 'Aam Aadmi Party',                color: '#1E88E5' },
  { id: 'SP',   en: 'SP',   local: 'Samajwadi Party',                color: '#C8102E' },
  { id: 'TMC',  en: 'AITC', local: 'All India Trinamool Congress',   color: '#009966' },
  { id: 'DMK',  en: 'DMK',  local: 'Dravida Munnetra Kazhagam',      color: '#808080' },
  { id: 'TVK',  en: 'TVK',  local: 'Tamilaga Vettri Kazhagam',       color: '#00897B' },
  { id: 'TDP',  en: 'TDP',  local: 'Telugu Desam Party',             color: '#F5C518' },
  { id: 'JDU',  en: 'JDU',  local: 'Janata Dal (United)',            color: '#558B2F' },
];

// 28 states + 8 UTs = 36 regions. No col/row — CJP uses a text-ranked list, not a geo-tile map.
const CJP_DISTRICTS = [
  { en: 'Andhra Pradesh',           local: '' },
  { en: 'Arunachal Pradesh',        local: '' },
  { en: 'Assam',                    local: '' },
  { en: 'Bihar',                    local: '' },
  { en: 'Chhattisgarh',             local: '' },
  { en: 'Goa',                      local: '' },
  { en: 'Gujarat',                  local: '' },
  { en: 'Haryana',                  local: '' },
  { en: 'Himachal Pradesh',         local: '' },
  { en: 'Jharkhand',                local: '' },
  { en: 'Karnataka',                local: '' },
  { en: 'Kerala',                   local: '' },
  { en: 'Madhya Pradesh',           local: '' },
  { en: 'Maharashtra',              local: '' },
  { en: 'Manipur',                  local: '' },
  { en: 'Meghalaya',                local: '' },
  { en: 'Mizoram',                  local: '' },
  { en: 'Nagaland',                 local: '' },
  { en: 'Odisha',                   local: '' },
  { en: 'Punjab',                   local: '' },
  { en: 'Rajasthan',                local: '' },
  { en: 'Sikkim',                   local: '' },
  { en: 'Tamil Nadu',               local: '' },
  { en: 'Telangana',                local: '' },
  { en: 'Tripura',                  local: '' },
  { en: 'Uttar Pradesh',            local: '' },
  { en: 'Uttarakhand',              local: '' },
  { en: 'West Bengal',              local: '' },
  { en: 'Andaman & Nicobar',        local: '' },
  { en: 'Chandigarh',               local: '' },
  { en: 'Dadra & Nagar Haveli',     local: '' },
  { en: 'Delhi',                    local: '' },
  { en: 'Jammu & Kashmir',          local: '' },
  { en: 'Ladakh',                   local: '' },
  { en: 'Lakshadweep',              local: '' },
  { en: 'Puducherry',               local: '' },
];

// ─── States registry ──────────────────────────────────────────────────────────
export const STATES = {
  tn: {
    id:         'tn',
    name:       'Tamil Nadu',
    nameLocal:  'தமிழ்நாடு',
    localFont:  "'Noto Sans Tamil', sans-serif",
    accent:     '#00E5FF',
    parties:    TN_PARTIES,
    partyById:  Object.fromEntries(TN_PARTIES.map(p => [p.id, p])),
    districts:  TN_DISTRICTS,
    strings: {
      voteQuestion:   'இலவசங்கள் இல்லாமல், செல்வாக்கு இல்லாமல் — உங்கள் உண்மையான விருப்பம் எது?',
      anonymityNote:  'எந்தத் தகவலும் சேமிக்கப்படவில்லை',
      pickDistrict:   'உங்கள் மாவட்டம்',
      pickParty:      'உங்கள் கட்சி',
      selectHint:     'மாவட்டத்தை தேர்ந்தெடுக்கவும்',
      castVote:       'வாக்களி',
      undoNote:       'ஐந்து வினாடிகளுக்குள் ரத்து செய்யலாம்.',
      districtLabel:  'மாவட்டம்',
      partyLabel:     'கட்சி',
      thankYou:       'வாக்களித்தமைக்கு நன்றி. நீங்கள் ஒரு பொறுப்புள்ள குடிமகன்.',
      alreadyVoted:   'நீங்கள் ஏற்கனவே வாக்களித்துவிட்டீர்கள்.',
      statewide:      'ஒட்டுமொத்த',
      liveResults:    'நேரடி முடிவுகள்',
      districtFocus:  'மாவட்ட பகுப்பாய்வு',
      yourDistrict:   'Your district',
      undoCancel:     'ரத்து',
      yourVote:       'உங்கள் வாக்கு',
      step1Local:     'உங்கள் மாவட்டம்',
      step2Local:     'ஒரு கட்சி',
      step3Local:     'ஒட்டுமொத்த முடிவு',
      disclaimer:       'பொழுதுபோக்கிற்கானது மட்டுமே.',
      resultsPending:   'வாக்குகள் எண்ணப்படுகின்றன. நிர்வாகி விரைவில் முடிவுகளை வெளியிடுவார்.',
      votingClosed:     'வாக்களிப்பு முடிந்துவிட்டது. இறுதி முடிவுகள் இங்கே.',
    },
  },
  wb: {
    id:         'wb',
    name:       'West Bengal',
    nameLocal:  'পশ্চিমবঙ্গ',
    localFont:  "'Noto Sans Bengali', sans-serif",
    accent:     '#0288D1',
    parties:    WB_PARTIES,
    partyById:  Object.fromEntries(WB_PARTIES.map(p => [p.id, p])),
    districts:  WB_DISTRICTS,
    strings: {
      voteQuestion:   'বিনামূল্যে পণ্য ছাড়া, প্রভাব ছাড়া — আপনার সত্যিকারের পছন্দ কী?',
      anonymityNote:  'কোনো তথ্য সংগ্রহ করা হয়নি',
      pickDistrict:   'আপনার জেলা',
      pickParty:      'আপনার দল',
      selectHint:     'জেলা বেছে নিন',
      castVote:       'ভোট দিন',
      undoNote:       'পাঁচ সেকেন্ডের মধ্যে বাতিল করা যাবে।',
      districtLabel:  'জেলা',
      partyLabel:     'দল',
      thankYou:       'ভোট দেওয়ার জন্য ধন্যবাদ। আপনি একজন দায়িত্বশীল নাগরিক।',
      alreadyVoted:   'আপনি ইতিমধ্যে ভোট দিয়েছেন।',
      statewide:      'সামগ্রিক',
      liveResults:    'সরাসরি ফলাফল',
      districtFocus:  'জেলা বিশ্লেষণ',
      yourDistrict:   'আপনার জেলা',
      undoCancel:     'বাতিল',
      yourVote:       'আপনার ভোট',
      step1Local:     'আপনার জেলা',
      step2Local:     'একটি দল',
      step3Local:     'সামগ্রিক ফলাফল',
      disclaimer:       'শুধুমাত্র বিনোদনের জন্য।',
      resultsPending:   'ভোট গণনা করা হচ্ছে। প্রশাসক শীঘ্রই ফলাফল প্রকাশ করবেন।',
      votingClosed:     'ভোটগ্রহণ শেষ হয়েছে। চূড়ান্ত ফলাফল এখানে দেখুন।',
    },
  },
  cjp: {
    id:          'cjp',
    name:        'India',
    nameLocal:   'Mock 2029 Lok Sabha',
    localFont:   "'Poppins', sans-serif",
    accent:      '#C8874E',
    isMock:      true,
    regionLabel: 'states/UTs',
    parties:     CJP_PARTIES,
    partyById:   Object.fromEntries(CJP_PARTIES.map(p => [p.id, p])),
    districts:   CJP_DISTRICTS,
    strings: {
      voteQuestion:   'No freebies, no propaganda — if elections were tomorrow, who gets your vote?',
      anonymityNote:  'No data collected',
      pickDistrict:   'Your state / UT',
      pickParty:      'Your party',
      selectHint:     'Select your state or UT',
      castVote:       'Vote',
      undoNote:       'You can undo within five seconds.',
      districtLabel:  'State / UT',
      partyLabel:     'Party',
      thankYou:       'Thanks for the mock vote. Cockroaches survive everything.',
      alreadyVoted:   'You have already voted.',
      statewide:      'National',
      liveResults:    'Live National Results',
      districtFocus:  'State-wise Breakdown',
      yourDistrict:   'Your state',
      undoCancel:     'Cancel',
      yourVote:       'Your Vote',
      step1Local:     'Your state/UT',
      step2Local:     'Pick a party',
      step3Local:     'National results',
      disclaimer:       'Unofficial · Unverified · Unserious.',
      resultsPending:   'Votes being counted. Admin will publish results soon.',
      votingClosed:     'Voting is closed. Final national results are here.',
    },
  },
};

// Backward-compat exports used by Confetti (fallback palette)
export const PARTIES     = TN_PARTIES;
export const PARTY_BY_ID = STATES.tn.partyById;
export const DISTRICTS   = TN_DISTRICTS;
